export default{
    lista:{
        method:'get',
        url:'tabelaprecorublica/configuracao/taxa/lista'
    },
    listatrabalhador:{
        method:'get',
        url:'trabalhador/pesquisa{/id}'
    },
    tabelapreco:{
        method:'get',
        url:'configuracao/editar{/id}'
    },
    cadastra:{
        method:'post',
        url:'configuracao/cadastro'
    },
    delete:{
        method:'delete',
        url:'configuracao/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'configuracao/editar{/id}'
    },
    update:{
        method:'post',
        url:'configuracao/update'
    }
}
